const NAME = "NINE_BOX_SETTINGS";

export default NAME;
